export default __webpack_public_path__ + "static/media/logoWhite.8f146249.svg";